import { Stack } from 'expo-router';
import React from 'react';
import ScreenAnalytics from 'shared/components/ScreenAnalytics/ScreenAnalytics';
import theme from 'shared/styles/theme';

function PublicLayout() {
  return (
    <>
      <ScreenAnalytics />
      <Stack
        screenOptions={{
          contentStyle: {
            backgroundColor: theme.color.background.primary,
          },
          headerShown: false,
        }}
      />
    </>
  );
}

export default PublicLayout;
